export const SETHUBUNGANINVESTOR = "SETHUBUNGANINVESTOR";
export const RESETHUBUNGANINVESTOR = "RESETHUBUNGANINVESTOR";
export const SETFILEBYID = "SETFILEBYID";
export const RESETFILEBYID = "RESETFILEBYID";